<template>
    <div class="competitionListBox">
        <div v-if="list.length">
            <CompetitionList
                :list="list"
                :userType="userType"
                :pageData="pageData"
            ></CompetitionList>
            <Pagination :pageData="pageData" @changePage="changeCurrent" v-show="pageData.total>pageData.pageSize"></Pagination>
        </div>
        <div v-else class="noContent">
            <NoContent></NoContent>
        </div>
    </div>
</template>
<script>
    import Add from '@/components/consultant/Add'
    import CompetitionList from '@/components/consultant/CompetitionList.vue'
    import Pagination from '@/components/consultant/Pagination.vue'
    import NoContent from '@/components/NoContent.vue'
    export default {
        name: "competitionListBox",
        components: {
            Add,
            CompetitionList,
            Pagination,
            NoContent
        },
        data() {
            return {
                userType: 2,
                studentId: sessionStorage.getItem('myStudentStudentId'),
                pageData: {
                    current:1,//当前页
                    pageSize:10,//每页多少条
                    totalPage:1,//总页数数
                    total:1//总条数
                },
                list: []
            }
        },
        created() {
            this.getList(this.pageData,1);
        },
        methods: {
            changeCurrent(value) {
                let current = value;
                this.getList(this.pageData,current);
            },
            // 获取竞赛信息列表
            getList(pageData,current){
                this.$ajax.post(this.G_acapi + this.ports.parent.student.studentMessage.competition.getCompetitionInfoListByParent, {
                    pageSize: pageData.pageSize,
                    pageNumber: current
                }, {
                    headers: {
                        token: window.sessionStorage.getItem('ymtxToken')
                    }
                }).then((res) => {
                    if (res.data.code == 2000) {
                        let page = res.data.data.page;
                        this.list = res.data.data.list;
                        this.pageData={
                            current:page.pageNumber,//当前页
                            pageSize:page.pageSize,//每页多少条
                            totalPage:page.count,//总页数数
                            total:page.count//总条数
                        };
                    }else{

                    }
                })
            },
        }

    }
</script>

<style scoped lang="less">
.competitionListBox {
    padding: 0 30px;
    min-height: 600px;
    background-color: #fff;
    .btn {
        cursor: pointer;
    }
    .addBtn {
        height: 32px;
        margin-bottom: 20px;
        .btn {
            float: right;
            width: 150px;
            height: 32px;
            background: linear-gradient(305deg, #3d90f6 0%, #2CB2FF 100%, #2CB2FF 100%);
            border-radius: 2px;
            border: 1px solid #D9D9D9;
            font-size: 16px;
            font-weight: 500;
            color: #fff;
            line-height: 32px;
            text-align: center;
            cursor: pointer;
        }
    }
}
</style>